import React, { useEffect, useState } from "react";
import {
  TextField,
  Button as MuiButton,
  Box,
  Typography as MuiTypography,
  IconButton as MuiIconButton,
  Grid,
  IconButton,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  FormControlLabel,
  Radio,
  RadioGroup,
  Paper,
} from "@mui/material";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import AddIcon from "@mui/icons-material/Add";
import Switch from "@mui/joy/Switch";
import { Divider, Input, notification } from "antd";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { AllTypoFontStyles, SettingsStyles } from "../../../Styles/styles";
import { DeleteContentIcon } from "../../../Svg/icons";
import { RiFontFamily } from "react-icons/ri";
import { useOrganizationMutation } from "../../../Redux/Slices/Organization/OrganizationapiSlice";
import {
  useAddTicketTypeMutation,
  useGetTicketTypesQuery,
  useDeleteTicketTypeMutation,
  useUpdateTicketTypeMutation,
  useGetProfileInformationQuery,
  useUpdateUserProfileMutation,
} from "../../../Redux/apis/ApiSlice";
import { useDispatch } from "react-redux";
import { setStripeFee } from "../../../Redux/Slices/stripeFee";

const crunchSound = "/audio/buzz.mp3";

const AppSettings = () => {
  const theme = useTheme();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const isLgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const [organizationMutation] = useOrganizationMutation();
  const { data: ticketTypes, refetch } = useGetTicketTypesQuery();
  const [addTicketType] = useAddTicketTypeMutation();
  const [deleteTicketType] = useDeleteTicketTypeMutation();
  const dispatch = useDispatch();
  const [organizationName, setOrganizationName] = useState();
  const [errors, setErrors] = useState({});
  const [feeDeduction, setFeeDeduction] = useState("");
  const {
    data: profileData,
    error,
    isLoading,
    refetch: profileRefetch,
  } = useGetProfileInformationQuery();

  const [updateUserProfile] = useUpdateUserProfileMutation();
  const [open, setOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  /*   useEffect(() => {
    if (open) {
      const audio = new Audio(crunchSound);
      audio.volume = 0.1; 
      audio.play();
    }
  }, [open]); */

  // tax:
  useEffect(() => {
    if (profileData) {
      const feeFromBackend = profileData.user.tax;
      setFeeDeduction(feeFromBackend ? "Participants" : "Company");
    }
  }, [profileData]);

  // Handle fee deduction change
  const handleFeeChange = async (event) => {
    const selectedValue = event.target.value;
    setFeeDeduction(selectedValue);

    const updatedTax = selectedValue === "Participants";

    try {
      // Call the update API
      await updateUserProfile({ tax: updatedTax }).unwrap();
      profileRefetch(); // Refresh the profile data after successful update
    } catch (err) {
      console.error("Error updating fee deduction:", err);
    }
  };
  //ta
  // Fetch and set categories
  // useEffect(() => {
  //   if (ticketTypes) {
  //     setCategories(ticketTypes.ticketType.map((ticket) => ticket.typeName));
  //   }
  // }, [ticketTypes]);

  useEffect(() => {
    if (ticketTypes) {
      const initialCategories = ticketTypes.ticketType.map((ticket) => ({
        name: ticket.typeName,
        isNew: false, // Existing categories from backend
      }));
      setCategories(initialCategories);
    }
  }, [ticketTypes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrganizationName({ ...organizationName, [name]: value });
  };

  const [categories, setCategories] = useState([]);
  const [upcharge, setUpcharge] = useState(false);

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setOpen(true);
  };

  const handleConfirmDelete = () => {
    if (deleteIndex !== null) {
      handleDelete(deleteIndex);
    }
    setOpen(false);
  };

  const handleDelete = async (index) => {
    try {

      const categoryToDelete = categories[index];

      const ticketToDelete = ticketTypes?.ticketType?.find(
        (ticket) => ticket.typeName === categoryToDelete.name
      );

      if (ticketToDelete) {
        await deleteTicketType(ticketToDelete.ticketTypeId).unwrap();
      }
      notification.success({
        message: "Category deleted successfully!",
      });
      // Use functional update to avoid stale state issues
      setCategories((prevCategories) =>
        prevCategories.filter((_, i) => i !== index)
      );
    } catch (error) {
      console.error(
        "Error deleting category:",
        error.data?.message || error.message
      );
    } finally {
      setDeleteIndex(null);
    }
  };

  const handleAddCategory = () => {
    setCategories([...categories, { name: "", isNew: true }]);
  };

  const handleOrganiztionSubmit = async () => {
    try {
      setIsSubmitted(true);

      const existingTypes = new Set(
        ticketTypes.ticketType.map((ticket) => ticket.typeName.toLowerCase())
      );

      // Get only new categories that are non-empty
      const newCategories = categories.filter(
        (cat) => cat.isNew && cat.name.trim()
      );

      // Separate duplicates
      const uniqueCategories = newCategories.filter(
        (cat) => !existingTypes.has(cat.name.trim().toLowerCase())
      );

      const duplicateCategories = newCategories.filter((cat) =>
        existingTypes.has(cat.name.trim().toLowerCase())
      );

   

      // Track successfully added categories
      const addedCategories = [];

      for (const category of uniqueCategories) {
        try {
          await addTicketType({ typeName: category.name.trim() }).unwrap();
        } catch {
          console.error(
            "Error submitting category:",
            error.data?.message || error.message
          );
        }
        addedCategories.push(category);
      
      }

      // Refresh data only if new categories were added
      if (addedCategories.length > 0) {
        await refetch();

        notification.success({
          message: "Ticket types created successfully!",
        });
      }

      if (duplicateCategories.length > 0) {
        notification.warning({
          message: "Duplicate categories can't be added!",
        });
      }

      // Keep the duplicates in the input list
      setCategories(categories.filter((cat) => !addedCategories.includes(cat)));
    } catch (error) {
      console.error(
        "Error submitting categories:",
        error.data?.message || error.message
      );
    } finally {
      setIsSubmitted(false);
    }
  };

  const InputStyles = {
    FieldStyle: {
      height: "47px",
      width: isLgDown ? "100%" : "377px",
    },
  };
  const fontStyles = {
    Headings: {
      fontSize: "16px",
      fontWeight: 600,
    },
    SubHeadings: {
      fontSize: "14px",
      fontWeight: 400,
      mt: 2,
    },
  };

  return (
    <Box sx={{ padding: 1 }}>
      <Grid>
        <Grid>
          <MuiTypography sx={fontStyles.Headings}>
            Customize Ticket Type
          </MuiTypography>
          <Typography sx={fontStyles.SubHeadings}>Type Name</Typography>

          {categories.map((category, index) => (
            <Grid container md={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 2,
                }}
              >
                <Input
                  size="large"
                  style={InputStyles.FieldStyle}
                  readOnly={!category.isNew}
                  placeholder="Type Name"
                  value={category.name} // ✅ Use category.name
                  onChange={(e) => {
                    const newCategories = [...categories];
                    newCategories[index].name = e.target.value;
                    setCategories(newCategories);
                  }}
                />

                <MuiIconButton
                  onClick={() => handleDeleteClick(index)}
                  color="error"
                >
                  <DeleteContentIcon />
                </MuiIconButton>
              </Box>
            </Grid>
          ))}
          <Box sx={{ display: "flex" }}>
            <MuiButton
              startIcon={<AddIcon />}
              onClick={handleAddCategory}
              style={{ marginBottom: "10px", marginTop: 10 }}
            >
              Add Type
            </MuiButton>
          </Box>
          <Divider />
          {/* <Box>
            <Paper
              elevation={3}
              sx={{
                padding: 3,
                borderRadius: 2,
                width: { xs: "100%", md: "40%" },
              }}
            >
              <Typography variant="h6" gutterBottom>
                3.5% Processing fee
              </Typography>
              <RadioGroup
                row
                value={feeDeduction}
                onChange={handleFeeChange}
                sx={{ justifyContent: "space-between", mt: 1 }}
              >
                <FormControlLabel
                  value="Company"
                  control={<Radio color="primary" />}
                  label="Company"
                  sx={{ marginRight: 2 }}
                />
                <FormControlLabel
                  value="Participants"
                  control={<Radio color="primary" />}
                  label="Participants"
                />
              </RadioGroup>
            </Paper>
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ fontSize: 14 }}>
                A 3.5% processing fee will be applied to {feeDeduction}.
              </Typography>
            </Box>
          </Box> */}
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: { xs: 3, sm: 3, md: 10, lg: 3, xl: 3 },
          // mr: 2,
          float: "right",
          flexDirection: { md: "row", sm: "column", xs: "column" },
          mt: 2,
        }}
      >
        {/*       <Button sx={SettingsStyles.ResetBtnStyles} variant="outlined">
          Reset Changes
        </Button> */}
        <Button
          sx={SettingsStyles.UpdateBtnStyles}
          variant="contained"
          color="primary"
          onClick={handleOrganiztionSubmit}
        >
          Update
        </Button>
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          <WarningAmberIcon color="warning" style={{ marginRight: 8 }} />
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deleting this ticket type will remove it from events. Proceed?{" "}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AppSettings;
